module.exports = "<ngx-loading [show]=\"loading\" [config]=\"{ backdropBorderRadius: '3px' }\" >\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/facebookroute/facebookroute.component.html
// module id = ./src/app/auth/facebookroute/facebookroute.component.html
// module chunks = main